import { visuallyHiddenStyle } from "../../theme/accessibility";
import { styled } from "../../theme/styled/styled/styled";

export const VisuallyHidden = styled.div(visuallyHiddenStyle);
